import React from 'react'

function GenderInput({ isSubmit, name, value, inputHandler, error }) {
  return (
    <div className={'mb-10'}>
      <span className={'text-base font-normal dark:text-slate-50'}>جنسیت</span>
      <div className="flex items-center mt-2">
        <label
          className={'ml-5 flex items-center cursor-pointer dark:text-slate-50'}
          htmlFor={'male'}
        >
          <input
            className={'ml-2 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300'}
            id={'male'}
            type="radio"
            name={name}
            disabled={isSubmit}
            value={'مرد'}
            checked={value === 'مرد'}
            onChange={inputHandler}
          />
          مرد
        </label>
        <label className={'flex items-center cursor-pointer dark:text-slate-50'} htmlFor={'female'}>
          <input
            className={'ml-2 w-4 h-4 text-blue-600 bg-gray-100 border-gray-300'}
            id={'female'}
            type="radio"
            name={name}
            value={'زن'}
            disabled={isSubmit}
            checked={value === 'زن'}
            onChange={inputHandler}
          />
          زن
        </label>
      </div>
      {error?.[name] && <p className={'text-rose-500'}>{error?.[name]}</p>}
    </div>
  )
}

export default React.memo(GenderInput)
